"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overlay = exports.OVERLAY_ANIMATION_DURATION = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["className", "visible"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
var OVERLAY_ANIMATION_DURATION = 300;
exports.OVERLAY_ANIMATION_DURATION = OVERLAY_ANIMATION_DURATION;
/**
 * Dark, semi-transparent overlay that covers main content while
 * focusing some other component, such as a modal or cubby.
 */
var Overlay = function Overlay(_ref) {
  var className = _ref.className,
    visible = _ref.visible,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('--tag-overlay bg-black', visible ? 'visible opacity-40' : 'invisible opacity-0', className),
    style: {
      transition: "opacity ".concat(OVERLAY_ANIMATION_DURATION, "ms ease-in-out, visibility ").concat(OVERLAY_ANIMATION_DURATION, "ms ease-in-out")
    }
  }, props));
};
exports.Overlay = Overlay;